import { Button } from '@main/complykit/components/button';
import { PropsWithChildren } from 'react';

type CardButtonProps = PropsWithChildren<{
  onPress: () => void;
  isPending?: boolean;
}>;

// The parent stretches it (button.md): every seat is a flex column.
export const CardButton = ({ onPress, isPending, children }: CardButtonProps) => (
  <Button variant="soft" isPending={isPending} onPress={onPress}>
    {children}
  </Button>
);
